module.exports = __webpack_public_path__ + "341504f4e3dfe41c6fc7cf88cf0b1672.jpg";